// SUP-346 — v2 port of the legacy `apiError(fieldName)` validator
// (ui/src/components/form/validators/api-error.js). It reads the form's
// `apiValidationErrors` through the validator's `vm` argument (@vuelidate/core calls
// every $validator as `rule.call(instance, value, siblingState, instance)` — the
// component instance running useVuelidate), matching the legacy `this`-bound read
// one-for-one. Returns `{ $valid, title }` so `$message` below can read the matched
// error's title straight off `$response` (@vuelidate/core assigns the validator's whole
// return value to `$response`).
export default function apiError(fieldName) {
  return {
    $validator(value, siblingState, vm) {
      const apiValidationErrors = (vm && vm.apiValidationErrors) || [];
      const matchedFieldError = apiValidationErrors
        .find((error) => error && error.meta && error.meta.field === fieldName);

      return { $valid: !matchedFieldError, title: matchedFieldError && matchedFieldError.title };
    },
    $message: ({ $response }) => $response && $response.title,
    $params: { type: 'apiError', fieldName },
  };
}
